import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { Loading as LoadingIcon } from '@pegasus/ui-components/components/icons/loading';
import { IconSize } from '@pegasus/ui-components/components/icons/types';
import Translate from '@client/components/shared/translation/Translate';
import { BellIcon, BellFullIcon } from '@client/components/shared/SvgIcons';

import styles from './styles.scss';

export class NotificationReminder extends PureComponent {
    static propTypes = {
        notificationOn: PropTypes.bool,
        loading: PropTypes.bool,
        campaign: PropTypes.object.isRequired,
        onReminderClick: PropTypes.func.isRequired
    }

    render() {
        const { notificationOn, loading } = this.props;
        const Bell = notificationOn ? BellFullIcon : BellIcon;

        return (
            <div
                styleName={classNames('campaign-reminder', { 'notification-on': notificationOn })}
                onClick={this.handleReminderClick}
            >
                <Translate message="campaigns.notifyMe" />
                {loading ? <LoadingIcon styleName="loading-icon" size={IconSize.S} /> : <Bell styleName="bell-icon" />}
            </div>
        );
    }

    handleReminderClick = () => {
        const { onReminderClick, campaign } = this.props;
        onReminderClick(campaign);
    }
}

export default CSSModules(NotificationReminder, styles, { allowMultiple: true });
